export function checkHttpStatus(response) {
  const { status } = response;

  if (status >= 400 && status <= 599) {
    window.location.href = "/error";
  }
}
